var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLipBalmAu = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.2 72",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.03 23.37H27.2l-1.1 1.1v28.55c.37.37.73.79 1.1 1.28h37.81c.37-.37.73-.79 1.1-1.28V24.47l-1.1-1.1h-3.47V18.8l-1.1-1.1h-9.13c-.37.37-.79.73-1.28 1.1v4.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2e3192",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M50.03 23.37H27.2l-1.1 1.1v28.55c.37.37.73.79 1.1 1.28h37.81c.37-.37.73-.79 1.1-1.28V24.47l-1.1-1.1h-3.47V18.8l-1.1-1.1h-9.13c-.37.37-.79.73-1.28 1.1v4.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M50.03 23.37H27.2l-1.1 1.1v28.55c.37.37.73.79 1.1 1.28h37.81c.37-.37.73-.79 1.1-1.28V24.47l-1.1-1.1h-3.47V18.8l-1.1-1.1h-9.13c-.37.37-.79.73-1.28 1.1v4.57Z"
  })));
};
export default SvgLipBalmAu;